import { Component, Input, OnChanges } from '@angular/core';

import { orderBy } from 'rev-shared/util/SortUtil';

import styles from './video-comment-list.module.less';

@Component({
	selector: 'video-comment-list',
	templateUrl: './VideoCommentList.Component.html'
})

export class VideoCommentListComponent implements OnChanges {
	@Input() public comments: any[];
	@Input() public isAscending: boolean;

	public readonly styles = styles;
	public sortedComments: any[];

	public ngOnChanges(): void {
		this.sortedComments = orderBy(this.comments, comment => comment.date, this.isAscending);
	}

	public toggleRepliesDisplay({ commentId, showReplies }: { commentId: string; showReplies: boolean; }) {
		const comment = this.comments.find(comment => comment.id === commentId);
		comment.showReplies = showReplies;
	}
}
